import { render, staticRenderFns } from "./WorkLoadTypePositions.vue?vue&type=template&id=52d64abf"
import script from "./WorkLoadTypePositions.vue?vue&type=script&lang=js"
export * from "./WorkLoadTypePositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports